/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types',
	'../../../widgets/livewidget/nls/StringResources'
], function(
	React,
	UI_Toolkit,
	PropTypes,
	StringResources
) {

	const { Component } = React;
	const { Button } = UI_Toolkit;

	class CustomVisualsComponentHeader extends Component {

		componentDidMount() {
			const { customVisAction } = this.props;
			const { refreshCustomVisDefinitions } = this.props.handlers;
			customVisAction.createUploadFileNode(refreshCustomVisDefinitions);
		}

		componentWillUnmount() {
			const { customVisAction } = this.props;
			customVisAction.removeUploadFileNode();
		}

		render () {
			const { customVisAction } = this.props;
			const openSelectBundleFileDialog = customVisAction.openSelectBundleFileDialog.bind(customVisAction);
			const addNewIcon = customVisAction.dashboardApi.getFeature('Icons').getIcon('add16');
			const addCustomVisLabel = StringResources.get('extVisAddCustomVisual');

			return (
				<div className='addNewCustomVisContainer'>
					<Button
						icon={addNewIcon.id}
						size='small'
						intent='primary'
						variant='icon'
						onClick={() => openSelectBundleFileDialog()}
						focusable={true}
						iconDescription={addCustomVisLabel}
						aria-label={addCustomVisLabel}
						tooltipAlignment='end'
					/>
				</div>
			);
		}
	}
	CustomVisualsComponentHeader.propTypes = {
		handlers: PropTypes.shape({
			refreshCustomVisDefinitions: PropTypes.func.isRequired
		}).isRequired,
		customVisAction: PropTypes.object.isRequired
	};

	return CustomVisualsComponentHeader;
});
